import { RouteConfig } from "vue-router";

const principal: RouteConfig = {
  path: "/",
  name: "principal",
  component: () => import(/* webpackChunkName: "principal" */ "@/views/Principal.vue"),
};

export default principal;
